import React from 'react';

const MoveInImage = props => (
  <svg
    width="280"
    height="230"
    viewBox="0 0 280 230"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="move-in" transform="translate(1)" fillRule="nonzero">
        <g id="Group" transform="translate(38)" fill="#65C9DB">
          <path
            d="M20.1,73.7 C20.5,74.5 21.5,74.9 22.4,74.5 C30.5,70.7 38.3,66.4 45.8,61.6 L48.3,65.3 C48.8,66 49.7,66.1 50.3,65.7 L51.7,64.7 L72.8,95.5 L79.5,95.5 L56.2,61.5 L57.8,60.4 C58.4,59.9 58.5,59.1 58,58.5 L55.5,54.9 C62.7,49.6 69.5,43.9 76,37.8 C76.4,37.5 76.6,37 76.6,36.5 C76.6,36 76.4,35.5 76.1,35.2 L43.5,1.5 C42.7,0.6 41.3,0.4 40.3,1.1 C36.9,3.1 28.2,8.4 20.3,13.8 C12.4,19.2 4.2,25.5 1.1,27.9 C0.2,28.6 -0.1,29.9 0.4,30.9 L20.1,73.7 C20.1,73.7 20.1,73.7 20.1,73.7 Z"
            id="Shape"
          />
          <path
            d="M108.4,71 C109.1,76 109.5,81.6 109.3,85.5 L90.9,85.5 L90.9,95.4 L130.9,95.4 L130.9,85.5 L112.9,85.5 C113.1,80.4 112.6,73.1 111.4,67.1 C134.3,70.6 134,44.1 134,44.1 C116.3,45.5 112,60.7 111.1,65.5 C110.7,63.9 110.3,62.5 109.9,61.2 C107.5,54.4 109.9,45.5 109.9,45.4 C110,45.2 110,45 110,44.9 C113.2,43.6 122,39.1 121,27.8 C121,27.8 113.3,29.1 109.7,34.2 C109.6,32 108.8,29.5 106.5,27.2 C106.5,27.2 103.6,30.3 103.2,34.1 C101,32 97.9,30.4 93.5,30.1 C93.5,30.1 93.3,45.8 106.2,45.3 C105.6,47.6 104.3,54.5 106,60.8 C102.8,54.1 96.2,46.4 83.2,45.3 C83.2,45.4 82.9,74.9 108.4,71 Z M107.9,41.3 C107.9,41.6 108,41.8 108,42.1 C107.9,41.9 107.9,41.7 107.8,41.5 C107.8,41.5 107.8,41.4 107.9,41.3 Z"
            id="Shape"
          />
        </g>
        <polygon
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          fill="#5FC3B5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="277.4 160.8 0.6 160.8 45.4 95.5 230 95.5"
        />
        <path
          d="M225.4,228.3 L50,228.3 C47.4,228.3 45.4,226.2 45.4,223.7 L45.4,95.9 L230,95.9 L230,223.7 C230,226.3 227.9,228.3 225.4,228.3 Z"
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          fill="#5FC3B5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M229,222.7 L229,98.8 L219.8,126.8 L219.8,227.1 L225.5,227.1 C227.5,227.1 229,224.6 229,222.7 Z"
          id="Shape"
          fill="#CBE8E3"
        />
        <polygon
          id="Shape"
          stroke="#636464"
          strokeWidth="2.5"
          fill="#CBE8E3"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="207.2 164.3 64 164.3 45.4 95.5 230 95.5"
        />
      </g>
    </g>
  </svg>
);

export default MoveInImage;
